export default "__VITE_ASSET__sb2WAZ2j__"